exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}home .closings{height:7.13vh;position:absolute;right:-.25vmin;top:-7.4vh}home .closings button{height:100%}home .closings button>div{background-color:#900;padding:0 1.5vw;height:100%}home .closings button:focus,home .closings button:hover{color:#000;background:linear-gradient(#f7f7f7,#000 55%,#000 70%,#d7d7d7)}home .closings button:focus>div,home .closings button:hover>div{background-color:#ffac25}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/home/home.scss
 ** module id = 50
 ** module chunks = 0
 **/